import React from 'react';
import { TableCell, TableRow, Typography } from '@mui/material';
import { Sync as SyncIcon } from '@mui/icons-material';
import NameIdRosterEditor from './NameIdRosterEditor';

/**
 * Admin: Case Owner name + Salesforce OWNER_ID pairs for OE L1 Snowflake sync.
 * Both fields are entered here directly -- Snowflake's case rows carry
 * OWNER_ID but no owner name, so there is no automatic lookup.
 */
const LakeCaseOwnersAdmin = () => (
  <NameIdRosterEditor
    icon={SyncIcon}
    title="L1 Case Owners"
    description="Enter each Case Owner's name and Salesforce OWNER_ID for the HighQ Global Backlog
      filter, then run OE Sync. At least one OWNER_ID is required. Names without an
      OWNER_ID are skipped."
    infoAlert={(
      <>
        <strong>Empty owner <code>&quot;&quot;</code> is always included.</strong> Cases with no OWNER_ID
        (null or empty) sync automatically — you do not need a blank row. Add only named people with their IDs.
      </>
    )}
    listKey="owners"
    idField="ownerId"
    idFieldLabel="Salesforce OWNER_ID"
    idPlaceholder="e.g. 005Hs00000DdfowIAB"
    loadUrl="/api/customer-issues/lakehouse/case-owners"
    saveUrl="/api/customer-issues/lakehouse/case-owners"
    addButtonLabel="Add owner"
    enableCsv
    csvFileName="l1-case-owners.csv"
    emptyStateText='No named Case Owners yet — add a row ("" still applies).'
    staticRow={(
      <TableRow sx={{ bgcolor: 'rgba(26,46,34,0.04)' }}>
        <TableCell>
          <Typography variant="body2" sx={{ fontFamily: 'monospace', color: 'text.secondary' }}>
            &quot;&quot;
          </Typography>
        </TableCell>
        <TableCell>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            always included (null or empty OWNER_ID)
          </Typography>
        </TableCell>
        <TableCell />
      </TableRow>
    )}
  />
);

export default LakeCaseOwnersAdmin;
